function Intro() {
  return (
    <div className="section intro">
      <div className="container">
        <figure className="map">
          <img src="images/yodogawa-map.png" alt="淀川" />
        </figure>
        <h2 className="main-title">
          <span className="theme">
            &lt;事業テーマ&gt;
            <br />
          </span>
          淀川を活用したコンテンツ造成事業
        </h2>
      </div>
      <p>
        本事業は令和５年度観光庁「インバウンドの地方誘客や消費拡大に向けた観光コンテンツ造成支援事業」の補助を受けて実施しています。{" "}
      </p>
    </div>
  );
}

export default Intro;
